import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutRoutingGuideList extends Layout {
    layoutheaderRoutingGuideList: LayoutHeader;
    sourceRoutingGuideProfile: DataSource;
    tableRoutingGuideList: Table;
}
